// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"243eaaa4","160":"df45828c","667":"4cdb394b","767":"bc65452b","787":"19dc588a"}[chunkId] + ".chunk.js";
};